import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const PreviewModalSubTitle = (props: {
  label: string;
  value: string | ReactNode;
}) => {
  return (
    <Stack>
      <Typography variant="subtitle1">{props.label}</Typography>

      <Typography>{props.value}</Typography>
    </Stack>
  );
};
